import React, { useState } from 'react';
import { useWizard, WizardStepLayout } from 'components/layout/wizards';
import TimedRedirect from 'components/layout/TimedRedirect/TimedRedirect';
import AttachWorkerToReminder from '../../../AttachWorkerToReminder/AttachWorkerToReminder';

export default function AttachRemindersStep() {
  const { data } = useWizard();
  
  const [success, setSuccess] = useState(false);

  if (success) {
    return (
      <TimedRedirect 
        url="/workers" 
        message="Worker successfully attached to reminder! Redirecting..." 
        isCentered
      />
    );
  }

  return (
    <WizardStepLayout
      title="Attach to Reminder"
      description="Select a reminder to attach this worker to."
      actions={null}
    >
      <AttachWorkerToReminder 
        workerId={data.createdWorkerId}
        onSuccess={() => setSuccess(true)}
        onCancel={() => setSuccess(true)}
        cancelLabel="Skip"
        showWorkerInfo={false}
      />
    </WizardStepLayout>
  );
}
